import  './index.scss'
import Quizes from './components/Quizes'
import FAQ from './components/FAQ'
import Entitlement from './components/Entitlement'
import React, { useState, useEffect } from 'react'
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom'
import { PageProvider } from './context/theme';
import { getCurrentPage } from './utils/api' 

import { createTheme, ThemeProvider } from '@mui/material/styles'; 
import rtlPlugin from 'stylis-plugin-rtl'; 
import { prefixer } from 'stylis'; 
import { CacheProvider } from '@emotion/react'; 
import createCache from '@emotion/cache'; 



const theme = createTheme({ 
  direction: 'rtl', // Both here and <body dir="rtl"> 
}); 

// Create rtl cache 
const cacheRtl = createCache({ 
  key: 'muirtl', 
  stylisPlugins: [prefixer, rtlPlugin], 
}); 

function App() {
  let [currentPageObject, setCurrentPageObject] = useState('')
  
  useEffect(
    () => {
      getCurrentPage().then(( currentPageObject ) => { 
        setCurrentPageObject( currentPageObject)
      }) 
    },
    []
  )
  
 
  return( 
    <Router>
      <PageProvider value={[currentPageObject, setCurrentPageObject]}>
        
        <CacheProvider value={cacheRtl}> 
            <ThemeProvider theme={theme}> 

              <Routes>
                <Route path='*' element={<h1>404</h1>}  />
                <Route path="/" element={<Quizes />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/entitlement" element={<Entitlement />} />
              </Routes> 

          </ThemeProvider> 
        </CacheProvider> 

      </PageProvider>
    </Router> 

  )
  
}

const container = document.getElementById('app');
createRoot(container).render(<App />);